import React, { useState } from "react";
import {
    Card,
    TextBox,
    Button,
    Select,
    IconInfo,
    TextArea,
    RadioGroup,
    RadioButton,
    FilePicker,
    Accordion,
    Checkbox
} from "@veneer/core";
import type { RootState } from '@store/store';
import { useAppSelector, useAppDispatch } from '@store/hooks';

import { setShippingAddressFormValidity } from '@store/reducers/form-equipment-physical-shipping-address-slice';
import { Trans,useTranslation } from 'react-i18next';

// Define the type for props
interface MyComponentProps {
  title: string;
  subContent: string;
  onchange:(data:boolean)=>void
}

const NewShippingAddress: React.FC<MyComponentProps> = ({ title, subContent, onchange }) => {
    const { t } = useTranslation();
    const [isShow, setIsShow] = useState<string>('OFF');
    const dispatch = useAppDispatch();
    const formShippingAddressData = useAppSelector((state) => state.formShippingAddressInfo.formShippingAddressData);

    const changeRadioHandler = (event: React.ChangeEvent<{}>, value: string) => {
        setIsShow(value); 
        onchange(value === '100000001');
        const isValid = false;

        dispatch(setShippingAddressFormValidity({
            isValid,
            formData: {...formShippingAddressData, ['showparts']:value}
        }));

    };

    return (
        <div className="row d-flex justify-content-start Part_ShipDiv">
            <div className="col-md-10">
                <h5 className="subtitle-large">{title}</h5>
                <p className="caption-regular">{subContent}</p>
                <div className="form-check d-flex Radio_div">
                    <RadioGroup
                        alignment="vertical"
                        id="radio-id"
                        value={formShippingAddressData.showparts}
                        name="partshipingradio"
                        onChange={changeRadioHandler}
                    >
                        <RadioButton
                            id="radio1-id"
                            name="partshipingradio"
                            value="100000000"
                            label={t("HPI.CreateCase.UseTheSameAddress",{defaultValue:'Use the same address as the equipment location (seen above)'})}
                        />
                        <RadioButton
                            id="radio2-id"
                            name="partshipingradio"
                            value="100000001"
                            label={t("HPI.CreateCase.EnterANewAddress",{defaultValue:'Enter a new address for shipping parts.'})}
                        />
                    </RadioGroup>
                </div>
            </div>
        </div>
    );
};

export default NewShippingAddress;


